import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const loadFseTab = async () => {
  const type = 'normal';
  if (document.querySelector(`#fse_${type}`).value !== 'false') return;

  Loader.show();
  const url = `${window.config.ePersonamService.ePersonamHost + '/' + window.locale}/business_units/discharge_letter_fse.json`;

  try {
    const response = await apiConnector().get(`${url}?type=${type}`);
    if (response.status == 200) {
      eventBus.$emit('tabFseLoaded', response.data);
    }
    Loader.hide();
  } catch (error) {
    errorManager(error);
    Loader.hide();
  }
};

const setListener = () => {
  document.querySelector(`*[data-fse-activator=normal]`).addEventListener('click', loadFseTab);
};

const init = () => {
  try {
    setListener();
  } catch (e) {
    errorManager(e);
  }
};

window.BusinessUnitEdit = {
  init: init,
};
